var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreatment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.226 47.6719V28.6875",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4675_13033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 216,
    height: 216
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H216V216H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4675_13033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.5 137.531H212.836V152.297C212.836 154.626 210.947 156.516 208.617 156.516H131.836C129.506 156.516 127.617 154.626 127.617 152.297V74.9634C127.617 72.6245 128.588 70.3911 130.298 68.7952L151.106 49.3737C152.278 48.2798 153.821 47.6719 155.424 47.6719H185.029C186.632 47.6719 188.175 48.2798 189.347 49.3737L210.156 68.7952C211.865 70.3911 212.836 72.6245 212.836 74.9634V122.766",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.242 90.2812H211.886",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.867 124.875H165.586C162.091 124.875 159.258 122.042 159.258 118.547V109.266C159.258 105.771 162.091 102.938 165.586 102.938H174.867C178.362 102.938 181.195 105.771 181.195 109.266V118.547C181.195 122.042 178.362 124.875 174.867 124.875Z",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1129 71.2969H7.38281C5.05322 71.2969 3.16406 69.4077 3.16406 67.0781V51.8906C3.16406 49.561 5.05322 47.6719 7.38281 47.6719H84.1641C86.4941 47.6719 88.3828 49.561 88.3828 51.8906V67.0781C88.3828 69.4077 86.4941 71.2969 84.1641 71.2969H34.8785",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0547 72.8502V152.297C82.0547 154.627 80.1655 156.516 77.8359 156.516H13.7109C11.3813 156.516 9.49219 154.627 9.49219 152.297V71.947",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3862 90.2812H80.9064",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9064 137.531H10.3862",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4141 124.875H41.1328C37.638 124.875 34.8047 122.042 34.8047 118.547V109.266C34.8047 105.771 37.638 102.938 41.1328 102.938H50.4141C53.9089 102.938 56.7422 105.771 56.7422 109.266V118.547C56.7422 122.042 53.9089 124.875 50.4141 124.875Z",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.391 168.816V157.16",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.062 156.966V168.816",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.281 181.828H142.172C141.007 181.828 140.062 180.884 140.062 179.719V171.281C140.062 170.116 141.007 169.172 142.172 169.172H198.281C199.446 169.172 200.391 170.116 200.391 171.281V179.719C200.391 180.884 199.446 181.828 198.281 181.828Z",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.051 16.0312H189.633C190.798 16.0312 191.742 16.9754 191.742 18.1406V26.5781C191.742 27.7433 190.798 28.6875 189.633 28.6875H122.18",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.933 28.6875H26.3672C25.202 28.6875 24.2578 27.7433 24.2578 26.5781V18.1406C24.2578 16.9754 25.202 16.0312 26.3672 16.0312H94.2553",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.961 35.7037V204.188C114.961 205.353 114.017 206.297 112.852 206.297H103.148C101.983 206.297 101.039 205.353 101.039 204.188V35.7678",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07 35.0156H98.9297C96.6001 35.0156 94.7109 33.1265 94.7109 30.7969V13.9219C94.7109 11.5923 96.6001 9.70312 98.9297 9.70312H117.07C119.4 9.70312 121.289 11.5923 121.289 13.9219V30.7969C121.289 33.1265 119.4 35.0156 117.07 35.0156Z",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7734 47.6719V28.6875",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7734 156.516V169.172",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.227 181.828V194.484",
    stroke: "#7f56d9",
    strokeWidth: 6.32812,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.13e8dcd95d24d5dc9443b902bede8107.svg";
export { ForwardRef as ReactComponent };